// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["styles/mda-contact-form-admin"], () => (__webpack_require__("./resources/scripts/contact-form.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["styles/mda-contact-form-admin"], () => (__webpack_require__("./resources/styles/mda-contact-form-admin.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
